export default __webpack_public_path__ + "static/media/picture-6.bc069001.png";